import HttpServiceBasic from 'services/HttpServiceBasic';

import { AGE_GATE_STATUS_COOKIE, AGE_GATE_STATUS } from 'shared/constants';

export default class AnonAgeGate {
    constructor() {
        this.http = new HttpServiceBasic();
        this.setListeners();
    }

    handleEvent(event, href) {
        if (document.querySelector('.overlayPrompt.active')) {
            event.preventDefault();
            return;
        }

        if ($.cookie(AGE_GATE_STATUS_COOKIE) !== AGE_GATE_STATUS.VALID) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.getPopup(href);
            return;
        }
    }

    getPopup(nextUrl) {
        return this.http
            .doGet('/anonymous-age-gate/')
            .then((resp) => {
                if (resp) {
                    let content = { ...resp, data: { ...resp.data, nextUrl } };

                    import('shared/popup/GlobalPopup.js')
                        .then((module) => {
                            new module.default(content);
                        })
                        .catch((error) => {});
                }
            })
            .catch(() => {});
    }

    setListeners() {
        document.addEventListener('DOMContentLoaded', () => {
            this.setBodyListerners();
            this.setMobileMenuListeners();
            this.setGeneralListeners();
            this.setFooterListeners();
            this.setHelpContactListeners();
        });
    }

    setBodyListerners() {
        document.querySelectorAll('.age-gate-trigger').forEach((item) => {
            if (item) {
                item.addEventListener('click', (event) => {
                    this.handleEvent(event, item.href);
                });
            }
        });
    }

    setGeneralListeners() {
        [
            document.querySelector('.all-access-upsell-button a'), // Upsell button
            document.querySelector('ul:nth-child(3) > li:nth-child(2) > a.age-gate-footer-trigger'), // Footer help/contact link
        ].forEach((item) => {
            if (item) {
                item.addEventListener('click', (event) => {
                    this.handleEvent(event, item.href);
                });
            }
        });
    }

    setMobileMenuListeners() {
        const burger = document.querySelector('.burger');
        if (burger) {
            document.querySelectorAll('.age-gate-mobile-menu').forEach((item) => {
                if (item) {
                    item.addEventListener('click', (event) => {
                        burger.click();
                        this.handleEvent(event, item.href);
                    });
                }
            });
        }
    }

    setFooterListeners() {
        document.querySelectorAll('a.site-navigation').forEach((item) => {
            if (item) {
                item.addEventListener('click', (event) => {
                    this.handleEvent(event, item.href);
                });
            }
        });
    }

    setHelpContactListeners() {
        document.querySelectorAll('a.information').forEach((item) => {
            if (item && item.title.toLowerCase().includes('help')) {
                item.addEventListener('click', (event) => {
                    this.handleEvent(event, item.href);
                });
            }
        });
    }
}
